import { PERMISSION_WILDCARD, TPermissionId } from '../constants/permissionIds';
import { IPermissionsResponse } from '../interfaces/permissions';

/**
 * Where the answer of `GET /permissions` stands:
 * - `pending`: it has not arrived, so every gated control stays hidden (never shown, then taken away);
 * - `failed`: it did not arrive, and the screen fails OPEN: the server is the layer that refuses;
 * - `ready`: the answer decides.
 */
export type TPermissionsStatus = 'pending' | 'failed' | 'ready';

export function permissionsStatus(answer: IPermissionsResponse | null, failed: boolean): TPermissionsStatus {
  if (answer !== null) {
    return 'ready';
  }
  return failed ? 'failed' : 'pending';
}

/**
 * The same rule the API applies: with enforcement off everything is allowed; otherwise an id is
 * allowed when the list holds it or the wildcard.
 */
export function isGranted(status: TPermissionsStatus, answer: IPermissionsResponse | null, id: TPermissionId): boolean {
  if (status === 'pending') {
    return false;
  }
  if (status === 'failed' || answer === null || !answer.enforced) {
    return true;
  }
  return answer.permissions.includes(PERMISSION_WILDCARD) || answer.permissions.includes(id);
}

export function isAnyGranted(
  status: TPermissionsStatus,
  answer: IPermissionsResponse | null,
  ids: ReadonlyArray<TPermissionId>,
): boolean {
  return ids.some((id) => isGranted(status, answer, id));
}
